import { makeStyles } from "@material-ui/core";
import React from "react";
import VCERNTypography from "./VCERNTypography";
const useStyles = makeStyles((theme) => ({
  title: {
    margin: "15px 0",
    fontWeight: "bold",
  },
}));
export default function HeadingWithLine({ children, variant }) {
  const classes = useStyles();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <VCERNTypography className={classes.title} variant={variant || "h6"}>
        {children}
      </VCERNTypography>
      <div
        style={{
          flex: 1,
          height: 1,
          background: "rgba(0,0,0,0.2)",
          marginLeft: 30,
        }}
      ></div>
    </div>
  );
}
